import { render, staticRenderFns } from "./videosync-add-or-update.vue?vue&type=template&id=5dd3cc7d&scoped=true&"
import script from "./videosync-add-or-update.vue?vue&type=script&lang=js&"
export * from "./videosync-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./videosync-add-or-update.vue?vue&type=style&index=0&id=5dd3cc7d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd3cc7d",
  null
  
)

export default component.exports